// Auto-generated from Simple Honda Flasher source (user-provided). ECM ID -> offsets.
// Keihin: exact per-ID start/checksum offset. Shindengen: Auto (dynamic checksum + SV850/SH850 routing).
export const HONDA_ECM_DB = {
  "0104080F01": {
    "part": "38770-K2F-N01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0104F00F01": {
    "part": "38770-K2F-N91",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102A40101": {
    "part": "38770-MKK-D02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "0100F91103": {
    "part": "38770-KVG-V42",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0101340F01": {
    "part": "38770-K25-901",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0101A10F01": {
    "part": "38770-K46-N01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "01018B0F01": {
    "part": "38770-K41-N01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "01006A0101": {
    "part": "38770-MFN-D01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01006A0301": {
    "part": "38770-MFN-F01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102F60102": {
    "part": "38770-MKJ-D02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "0101390102": {
    "part": "38770-MGC-D32",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01011B0F02": {
    "part": "38770-K15-903",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0101DA0F01": {
    "part": "38770-K15-921",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0103130F11": {
    "part": "38770-K15-888",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0103130F01": {
    "part": "38770-K15-601",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102E70F01": {
    "part": "38770-K18-961",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102A22101": {
    "part": "38770-K0A-R11",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0101080801": {
    "part": "38770-KVK-B31",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0102B70401": {
    "part": "38770-K0A-A01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "01004C0701": {
    "part": "38770-MFM-651",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01004C0601": {
    "part": "38770-MFM-702",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101F20101": {
    "part": "38770-MJW-D51",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101F20F01": {
    "part": "38770-MJW-N41",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101F20801": {
    "part": "38770-MJW-B41",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101250101": {
    "part": "38770-MGZ-D02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101250501": {
    "part": "38770-MGZ-A03",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101250B02": {
    "part": "38770-MGZ-C03",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101250B01": {
    "part": "38770-MGZ-C02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101DE0101": {
    "part": "38770-MJW-D91",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101DE0F01": {
    "part": "38770-MJW-961",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102780F01": {
    "part": "38770-MJW-NM1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102780D01": {
    "part": "38770-MJW-???",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100390101": {
    "part": "38770-MFG-D02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01019C0101": {
    "part": "38770-MJE-D41",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01027D0D01": {
    "part": "38770-MJE-TB1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01014E1201": {
    "part": "38770-MJE-G12",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01019C1201": {
    "part": "38770-MJE-G52",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0103050101": {
    "part": "38770-MKN-D51",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0103BF0E01": {
    "part": "38770-MKN-HF2",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0100300101": {
    "part": "38770-MFA-D03",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01000F0202": {
    "part": "38770-MEL-613",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFFC"
  },
  "01000F0302": {
    "part": "38770-MEL-622",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFFC"
  },
  "01000F0102": {
    "part": "38770-MEL-643",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFFC"
  },
  "01001A0101": {
    "part": "38770-MEL-D01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFFC"
  },
  "01002B0401": {
    "part": "38770-MEL-A21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01002B0402": {
    "part": "38770-MEL-A22",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01002B0301": {
    "part": "38770-MEL-F21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01002B0502": {
    "part": "38770-MEL-L22",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01002B0101": {
    "part": "38770-MEL-D21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01005E0103": {
    "part": "38770-MFL-644",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01005E0601": {
    "part": "38770-MFL-702",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01005E0301": {
    "part": "38770-MFL-622",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01005E0503": {
    "part": "38770-MFL-773",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01005E0401": {
    "part": "38770-MFL-671",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B00301": {
    "part": "38770-MFL-741",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B00401": {
    "part": "38770-MFL-691",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B00501": {
    "part": "38770-MFL-861",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B00801": {
    "part": "38770-MFL-871",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B00102": {
    "part": "38770-MFL-761",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B00601": {
    "part": "38770-MFL-J41",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B70601": {
    "part": "38770-MFL-J21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B70501": {
    "part": "38770-MFL-L21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B70301": {
    "part": "38770-MFL-F21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B70101": {
    "part": "38770-MFL-D21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100B70401": {
    "part": "38770-MFL-A21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100F30501": {
    "part": "38770-MGP-L01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100F30301": {
    "part": "38770-MGP-F01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100F30401": {
    "part": "38770-MGP-A01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100F30601": {
    "part": "38770-MGP-J01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100F30101": {
    "part": "38770-MGP-D01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101830D01": {
    "part": "38770-MGP-T42",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101830401": {
    "part": "38770-MGP-A92",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101830302": {
    "part": "38770-MGP-F63",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101830101": {
    "part": "38770-MGP-D62",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102480401": {
    "part": "38770-MKF-A22",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "0102490E01": {
    "part": "38770-MKF-H11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "0102490501": {
    "part": "38770-MKF-L13",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "0102490101": {
    "part": "38770-MKF-D43",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "0103380D01": {
    "part": "38770-MKFA-A22",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "0103380101": {
    "part": "38770-MKFA-DK2",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "01005EFD74": {
    "part": "38770-NLR-B31",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102850111": {
    "part": "38770-MKFA-D72",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "0102850101": {
    "part": "38770-MKF-D72",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "01028501FF": {
    "part": "38770-NLS-000",
    "maker": "Keihin",
    "start": "0",
    "checksum": "FFFF8"
  },
  "0100C60102": {
    "part": "38770-KTY-H52",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0102A10101": {
    "part": "38770-K98-E02",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0100FA1001": {
    "part": "38770-KPP-N02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0101110F01": {
    "part": "38770-KPP-602",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0101B10F01": {
    "part": "38770-K45-N01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102040F01": {
    "part": "38770-K45-N42",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102A00D01": {
    "part": "38770-K94-T02",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0103250F01": {
    "part": "38770-K45-NA1",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0103250F11": {
    "part": "38770-K45-NA1",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0100C50D02": {
    "part": "38770-KPP-T03",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0100B80502": {
    "part": "38770-KYJ-922",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0100B80F01": {
    "part": "38770-KYJ-971",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0101790F02": {
    "part": "38770-K33-N03",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "0101790101": {
    "part": "38770-K33-D22",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "0101320671": {
    "part": "38770-KYJ-R11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "18FFE"
  },
  "0101E40601": {
    "part": "38770-K64-J01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0101E40F03": {
    "part": "38770-K64-N04",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0101E40F11": {
    "part": "38770-K64-N01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0103DC0F01": {
    "part": "38770-K64-NB1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0101740101": {
    "part": "38770-K33-D02",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "0102B70D02": {
    "part": "38770-KOA-T11",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0101250701": {
    "part": "38770-MGZ-U02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101DD0F01": {
    "part": "38770-MJW-N11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101DD0D01": {
    "part": "38770-MJW-T11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102F20511": {
    "part": "38770-MJW-AQ1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102F20111": {
    "part": "38770-MJW-DR1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100E00101": {
    "part": "38770-MGM-D11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100020302": {
    "part": "38770-MEE-622",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFE0"
  },
  "0100020202": {
    "part": "38770-MEE-612",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFE0"
  },
  "0100020203": {
    "part": "38770-MEE-613",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFE0"
  },
  "01001B0301": {
    "part": "38770-MEE-F02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFFC"
  },
  "01001B0101": {
    "part": "38770-MEE-D01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFFC"
  },
  "01001B0401": {
    "part": "38770-MEE-A02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFFC"
  },
  "0100330103": {
    "part": "38770-MFJ-D04",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100330302": {
    "part": "38770-MFJ-F03",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01007C0102": {
    "part": "38770-MFJ-D42",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101420101": {
    "part": "38770-MJC-D01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101420401": {
    "part": "38770-MJC-A01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100330171": {
    "part": "38770-N1A-D00",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101420171": {
    "part": "38770-N1A-D11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01014E0401": {
    "part": "38770-MJE-A02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01014E0D03": {
    "part": "38770-MJE-T15",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01019C0D02": {
    "part": "38770-MJE-T52",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102101011": {
    "part": "38770-MJE-S11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01027D0701": {
    "part": "38770-MJE-VB1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01027D0101": {
    "part": "38770-MJE-BB1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01027D0E02": {
    "part": "38770-MJE-HB3",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01031A0101": {
    "part": "38770-MKN-D11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01031A1801": {
    "part": "38770-MKN-U11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01031A0D01": {
    "part": "38770-MKN-T11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0103BE0E01": {
    "part": "38770-MKN-HB2",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01031A1201": {
    "part": "38770-MKN-DB1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01031A0501": {
    "part": "38770-MKN-L32",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01025C0F01": {
    "part": "38770-MKG-N52",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102560101": {
    "part": "38770-MJP-DA1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0102DE0501": {
    "part": "38770-KYK-D12",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102DD0501": {
    "part": "38770-K28-A62",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102320F01": {
    "part": "38770-K84-901",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0103160801": {
    "part": "38770-K99-B02",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "01011A0D01": {
    "part": "38770-KZZ-902",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "01011A0503": {
    "part": "38770-KZZ-914",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "0102360D01": {
    "part": "38770-KZZ-J01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102360101": {
    "part": "38770-KZZ-J81",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "01015B0D01": {
    "part": "38770-KZZ-A22",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "0102890101": {
    "part": "38770-K95-A41",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "0102360F01": {
    "part": "38770-KZZ-L41",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0104070D01": {
    "part": "38770-K1T-T01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0104070501": {
    "part": "38770-K1T-A11",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102E80501": {
    "part": "38770-MKE-A71",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "0103B60503": {
    "part": "38770-MKE-AF3",
    "maker": "Keihin",
    "start": "C000",
    "checksum": ""
  },
  "0102E90501": {
    "part": "38770-MKE-A81",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "0103261801": {
    "part": "38770-K47-M01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "01009C0101": {
    "part": "38770-MEW-D41",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01029E1801": {
    "part": "38770-K76-M02",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102B50D01": {
    "part": "38770-K76-T62",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "01008F0101": {
    "part": "38770-MFT-642",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100ED0101": {
    "part": "38770-MGF-D12",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100FB0E02": {
    "part": "38770-KYZ-T03",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "01010C1101": {
    "part": "38770-KYZ-V21",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "01015F1101": {
    "part": "38770-KYZ-V71",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0103141101": {
    "part": "38770-K73-V42",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0103110F01": {
    "part": "30400-K0J-N01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101350501": {
    "part": "38770-K26-911",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0101350101": {
    "part": "38770-K26-931",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0102130501": {
    "part": "38770-K26-B13",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102570501": {
    "part": "38770-K26-C31",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0101CA0F01": {
    "part": "38770-K56-N11",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0103920F01": {
    "part": "38770-K56-NJ1",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0801DF0101": {
    "part": "38770-MKA-D71",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01006D1101": {
    "part": "38770-GGE-941",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0100B41101": {
    "part": "38770-GGE-901",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0101700F01": {
    "part": "38770-KYE-942",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0102CA0501": {
    "part": "38770-K0F-A01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0101820101": {
    "part": "38770-MJL-Y11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101220801": {
    "part": "38770-MCG-602",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "01025A0D01": {
    "part": "38770-K87-T52",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "0101870F02": {
    "part": "38770-K03-N32",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102E40F01": {
    "part": "38770-K58-N41",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102D71F01": {
    "part": "38770-KPG-H01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0101CD1801": {
    "part": "38770-K56-M01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0103931801": {
    "part": "38770-K56-M91",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0D02FC0401": {
    "part": "38770-HR6-MO2",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0104130F01": {
    "part": "30400-K2F-N11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01027F0F01": {
    "part": "30400-K93-N01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102810D01": {
    "part": "30400-K93-T01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "01006B0801": {
    "part": "38770-GFM-601",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0100450103": {
    "part": "38770-KTW-903",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0100530101": {
    "part": "38770-KTW-B02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0102B10101": {
    "part": "38770-K53-DB2",
    "maker": "Keihin",
    "start": "0",
    "checksum": "DFEF"
  },
  "0101B80103": {
    "part": "38770-K53-D03",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0101C90F01": {
    "part": "38770-K56-N01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0101021101": {
    "part": "38770-KZL-E12",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "01011E0F01": {
    "part": "38770-KZL-C31",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "01030E0501": {
    "part": "38770-K0G-962",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0101BA0D01": {
    "part": "38770-KZV-A61",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0100E80F02": {
    "part": "38770-KYZ-713",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0801EB0502": {
    "part": "38770-HL6-A05",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0101FA0F01": {
    "part": "30400-K46-N21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101F80F01": {
    "part": "30400-K46-N31",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0102F80F01": {
    "part": "30400-K46-NA1",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0101200F01": {
    "part": "8770-K18-902",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0101F30F01": {
    "part": "38770-K18-941",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0100AA0301": {
    "part": "38770-MGE-623",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0101030101": {
    "part": "38770-MGE-D01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0101030301": {
    "part": "38770-MGE-F11",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0101190101": {
    "part": "38770-MGE-D41",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0800AB0301": {
    "part": "38770-MGE-F02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0800AB0101": {
    "part": "38770-MGE-D02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0100FC0101": {
    "part": "38770-MGH-641",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0801040101": {
    "part": "38770-MGH-D21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0801040301": {
    "part": "38770-MGH-F21",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "08017D0101": {
    "part": "38770-MGH-N12",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "08017D0301": {
    "part": "38770-MGH-M12",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "01007B0101": {
    "part": "38770-MFR-642",
    "maker": "Keihin",
    "start": "0",
    "checksum": "3FFF8"
  },
  "0100CE0D02": {
    "part": "38770-KWW-643",
    "maker": "Keihin",
    "start": "4000",
    "checksum": "7600"
  },
  "0101880D01": {
    "part": "38770-K03-H01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102681101": {
    "part": "38770-G90-V02",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "01034C0D01": {
    "part": "38770-K58-TC2",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102B90D01": {
    "part": "38770-K58-T81",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0102AD1801": {
    "part": "38770-K73-M41",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0101CB1101": {
    "part": "38770-K56-V01",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "0103591101": {
    "part": "38770-K56-V51",
    "maker": "Keihin",
    "start": "8000",
    "checksum": "0"
  },
  "08024C0101": {
    "part": "38770-MKH-D01",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "08024CFFFF": {
    "part": "38770-MKH-D22",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0802E60E01": {
    "part": "38770-MKH-C02",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0802E60E02": {
    "part": "38770-MKH-C03",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0802E60102": {
    "part": "38770-MKH-D23",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "08024CFFFE": {
    "part": "38770-MKH-D42",
    "maker": "Keihin",
    "start": "0",
    "checksum": "7FFF8"
  },
  "0101310802": {
    "part": "38770-KWT-703",
    "maker": "Keihin",
    "start": "E0000",
    "checksum": "B000"
  },
  "01046B0F01": {
    "part": "30400-K2SA-N02",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01037B0F01": {
    "part": "30400-K0WA-N01",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01037C0D01": {
    "part": "30400-K0WF-T01",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01012F1101": {
    "part": "30400-K12-901",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01012F1102": {
    "part": "30400-K12-903",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01012F1103": {
    "part": "30400-K12-903",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01037A0F02": {
    "part": "30400-K1AA-N02",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01037A0F03": {
    "part": "30400-K1AA-N03",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103790F02": {
    "part": "30400-K1AA-N12",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103790F03": {
    "part": "30400-K1AA-N13",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0104040F01": {
    "part": "30400-K1ZG-N21",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0104030F01": {
    "part": "30400-K1ZG-N31",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101D40F01": {
    "part": "30400-K25G-601",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101D30F01": {
    "part": "30400-K25G-611",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101411101": {
    "part": "30400-K27-V01",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101411102": {
    "part": "30400-K27-V02",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101AB1101": {
    "part": "30400-K27-V51",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101AB1102": {
    "part": "30400-K27-V52",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101AB1103": {
    "part": "30400-K27-V53",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101461101": {
    "part": "30400-K29-901",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101461102": {
    "part": "30400-K29-902",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101461103": {
    "part": "30400-K29-903",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102170A01": {
    "part": "30400-K36J-N11",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102180F01": {
    "part": "30400-K50A-T02",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101C40F01": {
    "part": "30400-K59A-A11",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102450F01": {
    "part": "30400-K59F-A01",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103060F01": {
    "part": "30400-K59J-A71",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103151801": {
    "part": "30400-K59-M01",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101E20F01": {
    "part": "30400-K60A-B01",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101C50F01": {
    "part": "30400-K60A-B11",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102470F01": {
    "part": "30400-K60K-B21",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102460F01": {
    "part": "30400-K60K-B31",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103080F01": {
    "part": "30400-K60R-B61",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103090F01": {
    "part": "30400-K60R-B71",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01030B0F03": {
    "part": "30400-K60S-M61",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102420F01": {
    "part": "30400-K81A-N02",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102410F01": {
    "part": "30400-K81A-N12",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102E30F01": {
    "part": "30400-K81H-N52",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102E20F01": {
    "part": "30400-K81H-N62",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103001101": {
    "part": "30400-K96-V01",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102970701": {
    "part": "30400-K97A-U01",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0102C70F01": {
    "part": "30400-K97G-N01",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103470F01": {
    "part": "30400-K97G-N31",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101230F01": {
    "part": "30400-KZRA-601",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101730F01": {
    "part": "30400-KZRA-651",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101690F01": {
    "part": "30400-KZRJ-B11",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101BE0F01": {
    "part": "30400-KZRM-B21",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0101AE0F01": {
    "part": "30400-KZRM-B31",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0104D90F01": {
    "part": "30400-K2VG-N32",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0104D80F01": {
    "part": "30400-K2VG-N42",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0105030F01": {
    "part": "30400-K1ZN-N41",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0105020F01": {
    "part": "30400-K1ZN-N51",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0104DA1F01": {
    "part": "30400-K2VJ-H31",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01048D0F01": {
    "part": "30400-KOWL-NB1",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "01048C0F01": {
    "part": "30400-K0WL-NA1",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103CF0D01": {
    "part": "30400-K1ZF-T11",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103090F03": {
    "part": "Shindengen",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  },
  "0103060F03": {
    "part": "Shindengen",
    "maker": "Shindengen",
    "start": "Auto",
    "checksum": "Auto"
  }
};
